import React, { FC } from 'react';
import MuiFormGroup, { FormGroupProps as MuiFormGroupProps } from '@mui/material/FormGroup';
import { BpDesignSystem } from '../../types';

export type FormGroupProps = BpDesignSystem.PropsWithChildren<MuiFormGroupProps & {}>;

export const FormGroup: FC<React.PropsWithChildren<FormGroupProps>> = ({ dataTest, ...props }) => (
  <MuiFormGroup data-test={dataTest} {...props} />
);
